module.exports = __webpack_public_path__ + "img/arya-orange.04c3ef53.png";